///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { SystemInfoDTO } from '../../../generated/shared-types.model';

@Injectable({
    providedIn: 'root'
})
export class AuthorizationManagerService {
    private static readonly AREA_PLANNER_PROFILE = 'areaPlanner';
    private areaPlannerFeatureEnabled = false;

    setSystemInfo(systemInfo: SystemInfoDTO): void {
        this.areaPlannerFeatureEnabled = systemInfo.activeProfiles.includes(AuthorizationManagerService.AREA_PLANNER_PROFILE);
    }

    canCreateAreaPlannerProject(): boolean {
        return this.areaPlannerFeatureEnabled;
    }
}
